import React from "react";
import { Box, Typography } from "@mui/material";

/**
 * Barra horizontal unica dividida en N segmentos de color + leyenda debajo.
 * Para composiciones tipo "share of cohort" o "non-adherence by root cause"
 * donde varias categorias suman ~100% y hace falta verlas juntas, no en filas
 * separadas (para eso ya esta BarList).
 *
 * @param {Array} items - { label, pct, color, value? } (value: texto opcional
 *   en la leyenda, p.ej. "528 · 22%"; si falta se usa `${pct}%`)
 * @param {number} height - alto de la barra en px
 */
function StackedBar({ items, height = 26 }) {
    return (
        <Box>
            <Box sx={{ display: "flex", height, borderRadius: 1.5, overflow: "hidden" }}>
                {items.map((it, i) => (
                    <Box
                        key={i}
                        sx={{
                            width: `${it.pct}%`,
                            bgcolor: it.color,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        {it.pct >= 8 && (
                            <Typography sx={{ fontSize: 11, fontWeight: 500, color: "#fff" }}>
                                {Math.round(it.pct)}%
                            </Typography>
                        )}
                    </Box>
                ))}
            </Box>
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5, mt: 1.25 }}>
                {items.map((it, i) => (
                    <Box key={i} sx={{ display: "flex", alignItems: "center", gap: 0.6 }}>
                        <Box sx={{ width: 9, height: 9, borderRadius: "2px", bgcolor: it.color, flexShrink: 0 }} />
                        <Typography sx={{ fontSize: 11.5, color: "text.secondary" }}>
                            {it.label}
                            {it.value != null && <> &middot; {it.value}</>}
                        </Typography>
                    </Box>
                ))}
            </Box>
        </Box>
    );
}

export default StackedBar;
